import { createContext, useEffect, useState } from "react";

const MyContext = createContext();

const MyProvider = ({ children }) => {
    const [auth, setAuth] = useState(null);
    const [listaEmpresa, setListaEmpresa] = useState([]);
    const [listaCarrinho, setListaCarrinho] = useState([]);
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        return localStorage.getItem('logged') === 'true';
    });

    const getUserAuth = ()=>{
        const data = localStorage.getItem('userAuth');

        if(data != null){
            let user = JSON.parse(data);
            
            setAuth({
                idUsuario: user.id,
                idFuncionario: user.id_funcionario,
                nome: user.nome,
                email: user.email,
                tipo: user.tipo,
            });
        }
    };

    const getCarrinhoProdutos = ()=>{
        const data = localStorage.getItem('carrinhoProdutos');

        if(data != null){
            setListaCarrinho(JSON.parse(data));
        }
    };

    const getInfoEmpresa = ()=>{
        const data = localStorage.getItem('empresa');

        if(data != null){
            setListaEmpresa(JSON.parse(data));
        }
    };

    useEffect(()=>{
        getUserAuth();
        getCarrinhoProdutos();
        getInfoEmpresa();
    }, []);

    return (
        <MyContext.Provider
            value={{
                auth, setAuth, isAuthenticated, setIsAuthenticated, listaCarrinho, setListaCarrinho, listaEmpresa, setListaEmpresa
            }}
        >
            { children }
        </MyContext.Provider>
    );
}

export { MyProvider, MyContext };

